var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7269 8.00018L5.70172 13.0254C5.62362 13.1035 5.62362 13.2301 5.70172 13.3082L6.40883 14.0153C6.48694 14.0934 6.61357 14.0934 6.69167 14.0153L12.3536 8.35343C12.5488 8.15817 12.5488 7.84158 12.3536 7.64632L6.69098 1.98436C6.61288 1.90626 6.48624 1.90626 6.40814 1.98436L5.70103 2.69147C5.62293 2.76957 5.62293 2.8962 5.70103 2.97431L10.7269 8.00018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/whiteArrow.806d658150fc5bbe814200cf6a49af35.svg";
export { ForwardRef as ReactComponent };